const map = {
	"./cst/user/DefineAuthorization": [
		11790,
		[
			8445,
			8993,
			136
		]
	],
	"./spoc/user/DefineAuthorization": [
		95561,
		[
			8445,
			8993,
			5661
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 78069;
module.exports = webpackAsyncContext;